import { Title } from './types';

const titleTheme: Title = {
	fontSizes: {
		uppercase: 1,
		subtle: 2,
		xs: 4,
		s: 5,
		m: 7,
		l: [7, 7, 7, 9],
		xl: [9, 9, 9, 10]
	},
	lineHeights: {
		uppercase: 2,
		subtle: 3,
		xs: 4,
		s: 5,
		m: 7,
		l: [6, 8],
		xl: [9, 10]
	},
	fontWeights: {
		uppercase: 'regular',
		subtle: 'bold',
		xs: 'bold',
		s: 'bold',
		m: 'semibold',
		l: 'semibold',
		xl: 'semibold'
	}
};

export default titleTheme;
